export default __webpack_public_path__ + "static/136-68be305d193b5af1b8a02299d1518f24.gif";